<template>
  <layout-main-inner
    title="客户交易统计"
    class="stat-inventory">
    <div slot="action">
      <el-radio-group v-model="type">
        <el-radio-button :label="1">全部客户</el-radio-button>
        <el-radio-button :label="2">小程序</el-radio-button>
      </el-radio-group>
    </div>
    <div>
      <layout-card-wrap
        v-if="type === 1"
        v-loading="loading"
        hasHeaderSlot>
        <template slot="title">本期数据</template>
        <div slot="form">
          <el-date-picker
            v-model="query.month"
            style="width: 140px"
            type="month"
            placeholder="选择月"
            format="yyyy 年 MM 月"
            :clearable="false"
            :editable="false"
            @change="fetch">
          </el-date-picker>
          <el-button
            style="margin-left: 10px"
            type="primary"
            @click="fetch">查询</el-button>
        </div>
        <el-row>
          <el-col :span="24">
            <summary-list
              :span="6"
              :list="summaryList" />
          </el-col>
        </el-row>
        <el-divider></el-divider>
        <el-row>
          <el-col :span="14">
            <v-title title="本期客户下单情况（前20名）" />
            <customer-chart :series="stock" />
          </el-col>
          <el-col :span="10">
            <v-title title="本期客户下单情况（20名以后）" />
            <customer-table :list="stock.list" />
          </el-col>
        </el-row>
        <el-divider></el-divider>
        <el-row>
          <el-col :span="12">
            <v-title title="本期客户下单金额占比" />
            <customer-precent-chart
              :legendData="pie1.legendData"
              :seriesData="pie1.seriesData"
              :selected="pie1.selected" />
          </el-col>
          <el-col :span="12">
            <v-title title="本期客户下单数量占比" />
            <customer-precent-chart
              :legendData="pie2.legendData"
              :seriesData="pie2.seriesData"
              :selected="pie2.selected" />
          </el-col>
        </el-row>
      </layout-card-wrap>

      <customer-wx v-else />
    </div>
  </layout-main-inner>
</template>

<script>
import moment from 'moment'
import _ from 'lodash'
import SummaryList from './busi/summary.vue'

import VTitle from './v-title.vue'
import CustomerChart from './customer/customer-chart.vue'
import CustomerTable from './customer/customer-table.vue'
import CustomerPrecentChart from './customer/customer-precent-chart.vue'
import CustomerWx from './customer-wx.vue'

const SLICE_NUM = 20
const SELECTED = 10
export default {
  name: 'StatCustomerNew',
  components: { SummaryList, CustomerChart, CustomerTable, CustomerPrecentChart, VTitle, CustomerWx },
  data() {
    return {
      loading: false,
      type: 1,
      query: {
        month: +moment()
      },
      summaryList: [
        {
          label: '平均客单价',
          value: 0
        },
        {
          label: '销售金额',
          value: 0
        },
        {
          label: '销售订单数',
          value: 0
        },
        {
          label: '下单客户数',
          value: 0
        }
      ],
      stock: {
        xAxis: [],
        s1: [],
        s2: [],
        s3: [],
        list: []
      },
      pie1: {
        legendData: [],
        seriesData: [],
        selected: {}
      },
      pie2: {
        legendData: [],
        seriesData: [],
        selected: {}
      }
    }
  },
  mounted() {
    this.fetch()
  },
  methods: {
    fetch() {
      this.loading = true
      const { month } = this.query
      this.$store.dispatch('stat/sumcustomertrading', {
        payload: {
          beginDate: moment(month).startOf('month').format('YYYYMMDD'),
          endDate: moment(month).endOf('month').format('YYYYMMDD')
        },
        success: (res) => {
          this.loading = false
          console.log(res)
          this.$set(this, 'summaryList', [
            {
              label: '平均客单价',
              value: res.data.averageCustomerAmount
            },
            {
              label: '销售金额',
              value: res.data.totalAmount
            },
            {
              label: '销售订单数',
              value: res.data.totalOrderCount
            },
            {
              label: '下单客户数',
              value: res.data.totalOrderedCustomerCount
            }
          ])
          this.formatData(res.data.customerTradings)
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    formatData(detail) {
      const stockAllList = []
      detail.forEach(i => {
        const { customerName, averageCustomerAmount, totalAmount, totalOrderCount, amountPercent, orderPercent } = i
        stockAllList.push({
          customerName, averageCustomerAmount, totalAmount, totalOrderCount, amountPercent, orderPercent
        })
      })
      const stockList = _.sortBy(stockAllList, (i) => -i.totalAmount)
      const chartList = stockList.slice(0, SLICE_NUM)
      this.stock.xAxis = chartList.map(i => i.customerName)
      this.stock.s1 = chartList.map(i => i.averageCustomerAmount)
      this.stock.s2 = chartList.map(i => i.totalAmount)
      this.stock.s3 = chartList.map(i => i.totalOrderCount)
      this.stock.list = stockList.slice(SLICE_NUM)

      const pie1Data = _.sortBy(stockAllList, (i) => -i.amountPercent)
      const pie1Result = this.formatPie(pie1Data, 'amountPercent')
      this.pie1.legendData = pie1Result.legendData
      this.pie1.seriesData = pie1Result.seriesData
      this.pie1.selected = pie1Result.selected

      const pie2Data = _.sortBy(stockAllList, (i) => -i.orderPercent)
      const pie2Result = this.formatPie(pie2Data, 'orderPercent')
      this.pie2.legendData = pie2Result.legendData
      this.pie2.seriesData = pie2Result.seriesData
      this.pie2.selected = pie2Result.selected
    },
    formatPie(list, key) {
      const legendData = []
      const seriesData = []
      const selected = {}
      list.forEach((i, idx) => {
        legendData.push(i.customerName)
        seriesData.push({
          name: i.customerName,
          value: i[key]
        })
        selected[i.customerName] = idx < SELECTED
      })
      return {
        legendData,
        seriesData,
        selected
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
    .grid-content {
        height 300px;
    }
</style>
